import { useState, useMemo } from 'react';

/**
 * useRangeState — local state for date range + computed API params.
 */
export default function useRangeState(initialPreset = 'today') {
  const [range, setRange] = useState({
    preset: initialPreset,
    start: null,
    end: null,
  });

  const apiParams = useMemo(() => {
    const out = { preset: range.preset };
    if (range.preset === 'custom' && range.start && range.end) {
      out.start = range.start;
      out.end = range.end;
    }
    return out;
  }, [range]);

  return [range, setRange, apiParams];
}
